import React, { FC } from 'react'
import ProductOriginalConnector, {
  ConnectorProps as ProductOriginalProps,
} from '../../../connectors/ProductsOriginal'
import { NOT_FOR_SALE } from '../../../helpers/constants'

const NotForSale: FC<ProductOriginalProps> = (props) => {
  const { productStatus, isArtistOnVacation } = props

  if (productStatus !== NOT_FOR_SALE) {
    return null
  }

  if (isArtistOnVacation) {
    return <span className='defaultTypographyMedium'>Temporarily Unavailable</span>
  }

  return <span className='defaultTypographyMedium'>This artwork is not for sale.</span>
}

export default ProductOriginalConnector(NotForSale)
